module.exports = __webpack_public_path__ + "img/logo-col.ac635c86.svg";